import React from 'react';

export function CruiseShip(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 463 163"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={props.className}
			ref={props.selectChildRef}
		>
			<path
				d="M10.489 72H463l-11.578 9.499a100.001 100.001 0 00-15.908 16.433L385.584 163H36.461L0 81.45 10.489 72z"
				fill="#F4F4F4"
			/>
			<path d="M56.455 50h349.832L423 72H31l25.455-22z" fill="#E4E4E4" />
			<path
				d="M69.88 42h305.88L390 50H56l13.88-8zM109.223 15h225.289L344 23H99.12l10.103-8zM88.5 31H356l6 3H83l5.5-3z"
				fill="#F4F4F4"
			/>
			<path
				d="M82.686 34h279.552L376 42H70l12.686-8zM99.11 23h244.837L356 31H88l11.11-8z"
				fill="#298CD5"
			/>
			<path d="M301.947 0H292l5.526 15H313L301.947 0z" fill="#E4E4E4" />
			<rect x={252} y={7} width={8} height={13} rx={4} fill="#F4F4F4" />
			<rect x={262} y={7} width={8} height={13} rx={4} fill="#F4F4F4" />
			<path fill="#C4C4C4" d="M59 56h18v9H59z" />
			<path fill="#E43637" d="M59 56h18v3H59z" />
			<path fill="#C4C4C4" d="M86 56h18v9H86z" />
			<path fill="#E43637" d="M86 56h18v3H86z" />
			<path fill="#C4C4C4" d="M113 56h18v9h-18z" />
			<path fill="#E43637" d="M113 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M149 56h18v9h-18z" />
			<path fill="#E43637" d="M149 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M176 56h18v9h-18z" />
			<path fill="#E43637" d="M176 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M203 56h18v9h-18z" />
			<path fill="#E43637" d="M203 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M239 56h18v9h-18z" />
			<path fill="#E43637" d="M239 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M266 56h18v9h-18z" />
			<path fill="#E43637" d="M266 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M293 56h18v9h-18z" />
			<path fill="#E43637" d="M293 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M329 56h18v9h-18z" />
			<path fill="#E43637" d="M329 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M356 56h18v9h-18z" />
			<path fill="#E43637" d="M356 56h18v3h-18z" />
			<path fill="#C4C4C4" d="M383 56h18v9h-18z" />
			<path fill="#E43637" d="M383 56h18v3h-18z" />
			<path
				fill="#24242C"
				d="M324 153h12v3h-12zM344 153h12v3h-12zM364 153h12v3h-12z"
			/>
			<circle cx={23} cy={90} r={5} fill="#24242C" />
			<circle cx={41} cy={90} r={5} fill="#24242C" />
			<circle cx={77} cy={90} r={5} fill="#24242C" />
			<circle cx={59} cy={90} r={5} fill="#24242C" />
			<circle cx={95} cy={90} r={5} fill="#24242C" />
			<circle cx={113} cy={90} r={5} fill="#24242C" />
			<circle cx={131} cy={90} r={5} fill="#24242C" />
			<circle cx={149} cy={90} r={5} fill="#24242C" />
			<circle cx={167} cy={90} r={5} fill="#24242C" />
			<circle cx={185} cy={90} r={5} fill="#24242C" />
			<circle cx={221} cy={90} r={5} fill="#24242C" />
			<circle cx={203} cy={90} r={5} fill="#24242C" />
			<circle cx={239} cy={90} r={5} fill="#24242C" />
			<circle cx={257} cy={90} r={5} fill="#24242C" />
			<circle cx={275} cy={90} r={5} fill="#24242C" />
			<circle cx={293} cy={90} r={5} fill="#24242C" />
			<circle cx={311} cy={90} r={5} fill="#24242C" />
			<circle cx={329} cy={90} r={5} fill="#24242C" />
			<circle cx={365} cy={90} r={5} fill="#24242C" />
			<circle cx={347} cy={90} r={5} fill="#24242C" />
			<circle cx={383} cy={90} r={5} fill="#24242C" />
			<circle cx={401} cy={90} r={5} fill="#24242C" />
			<circle cx={419} cy={90} r={5} fill="#24242C" />
		</svg>
	);
}

export default CruiseShip;
